import EntityFormProvider from '@shared/components/forms/auto-form/entity-form-provider/entity-form-provider.vue';
import StdForm from '@shared/components/forms/auto-form/std-form/std-form.vue';
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { Coupon } from '@accounting/interfaces/coupon';

@Component({
  name: 'bpc-coupon-form',
  components: {
    'bpc-std-form': StdForm,
  },
})
export default class CouponForm extends Vue {
  $refs: {
    // resourceForm: InstanceType<typeof ResourceForm> & { saveEntity(): void };
    stdForm: InstanceType<typeof StdForm> & {
      saveEntity(): void;
      formModel: any;
      onDeleteMediaFile(): void;
      searchEntity(): void;
      extraData: string | AnyEntity;
      formProvider: EntityFormProvider;
    };
  };
  @Prop([String, Number]) readonly entityId: string | number;
  @Prop([Object]) readonly value: AnyEntity;
  @Prop({ type: String, default: 'default' }) formConfigName: string;
  @Prop({ type: Boolean, default: false }) disabled: string;

  public entity: string = 'coupon';
  public permissionEntityNameToUse: string = 'coupons';
  public formModel: Coupon = null;

  // created() {}
  mounted() {
    this.$root.$on('setRemainingNumberOfUses', val => {
      this.$refs.stdForm.formModel.remaining_number_of_uses = this.$refs.stdForm.formModel.given_number_of_uses;
    });
  }

  destroyed() {
    /* this.$root.$off('changeActivityType'); */
  }

  onFormSaved(e) {
    this.$emit('entity-saved', e);
  }
  onSavingEntity(event) {
    this.$emit('saving-entity', event);
  }
  deleteMediaFile(mediaId) {
    this.$emit('delete-media-file', { mediaId: mediaId, entityId: this.entityId });
  }
  saveEntity() {
    this.$refs.stdForm.saveEntity();
  }

  setSelectedContacts(contacts: any) {
    this.$set(this.$refs.stdForm.formModel, 'contact_id', contacts);
  }

  setEntityAttributesAfterSave() {
    const newEntity = {} as Coupon;
    Object.keys(this.formModel).forEach(key => {
      this.$set(newEntity, key, null);
    });

    this.$set(newEntity, 'status', this.formModel.status);
    this.$set(this.$refs.stdForm, 'formModel', newEntity);
  }

  @Watch('formModel', { immediate: true, deep: true })
  onFormModelChange() {
    this.$emit('input', this.formModel);
  }

  onModelLoaded(event) {
    this.$emit('model-loaded', event);
  }
}
